/**
 * Created by andrey on 23.08.18.
 */

const CoefAnimation = BaseAnimation.extend({ 
    ctor: function () {
        this._super(bundles.coef.jsons.coef_animation_json);
    }
});

CoefAnimation.fillPool = function () {
    for (let i = 0; i < 6; i++) {
        cleverapps.pool.putInPool(new CoefAnimation());
    }
};

CoefAnimation.factory = function () {
    return cleverapps.pool.hasObject(CoefAnimation) ? cleverapps.pool.getFromPool(CoefAnimation) : undefined;
};